import React from 'react';

import PropTypes from 'prop-types';
import styles from '../Widget.less';

export default class WidgetFrame extends React.Component {
  getClassName = () => styles[this.props.appearance];

  render() {
    return <div className={this.getClassName()}>{this.props.children}</div>;
  }
}

WidgetFrame.defaultProps = {
  appearance: 'outerFrame',
};

WidgetFrame.propTypes = {
  appearance: PropTypes.oneOf(['outerFrame', 'noPaddingFrame', 'noPaddingNoShadowFrame']),
};
